import Config from '$root/Config';

export function volume(value = 0, maxValue) {
	const vol = Math.ceil(Config.factors.literToGarbageBags * value);
	return maxValue && vol > maxValue ? `${maxValue}+` : vol;
}

export default { volume };
